module.exports = __webpack_public_path__ + "static/media/SAJ_01.57b1b457.jpeg";